// English entries are only needed for plural forms; every other string falls back to its key.
const en = {
  '{count} Bonus Videos': { one: '{count} Bonus Video', other: '{count} Bonus Videos' },
  '{count} expire {date}': { one: '{count} expires {date}', other: '{count} expire {date}' },
  'minutes (unit)': { one: 'minute', other: 'minutes' },
  'hours (unit)': { one: 'hour', other: 'hours' },
  "That's {count} coffee breaks": { one: "That's {count} coffee break", other: "That's {count} coffee breaks" },
  "That's like watching {count} full football matches": {
    one: "That's like watching {count} full football match",
    other: "That's like watching {count} full football matches",
  },
  "That's {count} full work days you didn't spend captioning": {
    one: "That's {count} full work day you didn't spend captioning",
    other: "That's {count} full work days you didn't spend captioning",
  },
  '{count} videos · vs. captioning by hand (~{rate} min per video minute)': {
    one: '{count} video · vs. captioning by hand (~{rate} min per video minute)',
    other: '{count} videos · vs. captioning by hand (~{rate} min per video minute)',
  },
  '+ {count} bonus videos available': {
    one: '+ {count} bonus video available',
    other: '+ {count} bonus videos available',
  },
  '{count} words': { one: '{count} word', other: '{count} words' },
  '{count} chunks': { one: '{count} chunk', other: '{count} chunks' },
  '{count} phrases': { one: '{count} phrase', other: '{count} phrases' },
};

export default en;
